import { useMemo } from "react";

const FloatingParticles = ({ count = 18 }) => {
  const particles = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: Math.random() * 1.5 + 0.5,
        duration: Math.random() * 30 + 20,
        delay: Math.random() * 20,
        opacity: Math.random() * 0.3 + 0.05,
      })),
    [count]
  );

  return (
    <div data-testid="floating-particles" className="absolute inset-0 z-0 pointer-events-none overflow-hidden will-change-transform">
      {particles.map((p) => (
        <div
          key={p.id}
          className="absolute rounded-full bg-cyan-400"
          style={{
            left: `${p.left}%`,
            bottom: `-4px`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            opacity: p.opacity,
            animation: `drift-up ${p.duration}s linear infinite`,
            animationDelay: `${p.delay}s`,
            willChange: "transform, opacity",
          }}
        />
      ))}
    </div>
  );
};

export default FloatingParticles;
